<template>
	<div style="position: relative;">
		<mylogin flag="0"></mylogin>
		<div style="width: 1200px;margin: 0 auto;display: flex;justify-content: flex-end;">
			<div class="mycon">
				<p class="mycon-p">账号登录</p>
				<input type="text" class="mycon-input" placeholder="请输入用户名" v-model="username" />
				<input type="password" class="mycon-input1" placeholder="请输入密码" v-model="password" />
				<!-- <div class="mycon-con">
					<input type="text" class="mycon-con-input" placeholder="请输入验证码" v-model="captcha" />
					<img :src="captchaImgUrl" alt class="captcha-imgUrl" @click="changeCaptcha" />
				</div>-->

				<button class="mycon-btn" @click="toLogin">登录</button>
				<p class="mycon-p1" v-if="ckphone">* 账号或密码错误</p>
				<div class="mycon-div">
					<router-link to="/password">
						<p class="mycon-div-p">忘记密码</p>
					</router-link>
					<router-link to="/register">
						<p class="mycon-div-p">立即注册</p>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mylogin from "../mylogin.vue";

	export default {
		name: "App",

		components: {
			mylogin
		},
		data() {
			return {
				show: true,
				count: "",
				timer: null,
				captchaImgUrl: "",
				phoneNum: "",
				password: "",
				captcha: "",
				ckphone: false,
				ckpassword: false,
				username: ""
			};
		},
		methods: {
			toLogin() {
				// // 判断手机号格式
				// this.ckphone = false;
				// var ckPhone = /^[1][3,4,5,7,8,9][0-9]{9}$/;
				// if (!ckPhone.test(this.phoneNum)) {
				//   console.log("手机号格式不正确");
				//   this.ckphone = true;
				//   return;
				// }
				this.$http
					.post("user/login?XDEBUG_SESSION_START=11622", {
						password: this.password,
						username: this.username,
						captcha: this.captcha
					})
					.then(res => {
						if (res.body.code == 1) {
							this.$cookies.set("token", res.body.data.userinfo.token);
							if (window.history.length >= 1) {
								window.location.href = "http://www.005.tv";
							} else {
								this.$router.push({
									name: "index"
								});
							}
						} else {
							this.ckphone = true;
						}
					});
			},
			changeCaptcha() {
				const randomIdenx = Math.floor(Math.random() * 1000);
				this.$http.get("user/captcha" + "/i=" + randomIdenx).then(res => {
					this.captchaImgUrl = res.url;
				});
			}
		},
		beforeMount() {
			console.log(this.$cookies.get("token"));
			this.$http.get("user/captcha").then(res => {
				this.captchaImgUrl = res.url;
			});
		} //生命周期 - 挂载之前
	};
</script>

<style>
	.mycon {
		width: 400px;
		height: 440px;
		margin-top: 95px;
		padding: 30px;
		box-sizing: border-box;
		background-color: #f5f5f5;
		position: absolute;
		top: 40px;
	}

	.mycon-p {
		text-align: center;
		font-size: 16px;
		color: #212121;
	}

	.mycon-input {
		width: 100%;
		height: 40px;
		margin-top: 40px;
		border-radius: 6px;
		box-sizing: border-box;
		border: 1px solid #b4b4b4;
		font-size: 16px;
		padding-left: 5px;
	}

	.mycon-input1 {
		width: 100%;
		height: 40px;
		margin-top: 20px;
		border-radius: 6px;
		box-sizing: border-box;
		border: 1px solid #b4b4b4;
		font-size: 16px;
		padding-left: 5px;
	}

	.mycon-con {
		width: 100%;
		height: 40px;
		display: flex;
		margin-top: 20px;
		justify-content: space-between;
	}

	.mycon-con-input {
		width: 190px;
		height: 40px;
		border-radius: 6px;
		box-sizing: border-box;
		border: 1px solid #b4b4b4;
		font-size: 16px;
		padding-left: 5px;
	}

	.mycon-con-btn {
		width: 130px;
		height: 40px;
		border: 1px solid #6bccd5;
		color: #6bccd5;
		border-radius: 6px;
		background-color: #fff;
		font-size: 16px;
	}

	.mycon-btn {
		width: 100%;
		height: 40px;
		border-radius: 6px;
		border: 0;
		background-color: #6bccd5;
		color: #fff;
		font-size: 16px;
		margin-top: 20px;
	}

	.mycon-p1 {
		font-size: 12px;
		color: #d10000;
		margin-top: 20px;
	}

	.mycon-div {
		width: 100%;
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;
	}

	.mycon-div-p {
		font-size: 12px;
		color: #212121;
		margin-left: 10px;
	}
	.captcha-imgUrl {
		width: 130px;
		height: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue